import React from 'react';
import { Row, Col } from 'antd';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import withAuthentication from 'hoc/authentication';
import Signin from 'components/Signin/Signin';
import Signup from 'components/Signup/Signup';
import styles from './Login.module.scss';


const Login = props => {
  const { isAuthenticated, location, hasForgotPassword } = props;

  return (
    isAuthenticated ?
      <Redirect to={location.state ? location.state.from : '/manage-request'} />
      : (
        <div>
          {hasForgotPassword
            ? (
              <Signup
                label="Changer de mot de passe"
                subtext="Vous avez oublié votre mot de passe ?"
                buttonLabel="Changer de mot de passe"
                message="Votre demande de changement de mot de passe a bien été prise en compte"
              />
            )
            : (
              <Row className={styles.row} gutter={24} type="flex">
                <Col
                  span={24}
                  sm={11}
                  className={styles.login}
                >
                  <Signin />
                </Col>
                <Col span={0} sm={2} className={styles.separator} />
                <Col
                  span={24}
                  sm={11}
                  className={styles.signup}
                >
                  <Signup
                    label="Créer un compte"
                    subtext="Vous n'avez pas encore de compte ?"
                    buttonLabel="Créer un compte"
                    message="Votre inscription a bien été prise en compte"
                  />
                </Col>
              </Row>
            )
          }
        </div>
      ));
};

const mapStateToProps = state => ({
  login: state.login,
  form: state.forms.login.$form,
  hasForgotPassword: state.appConfig.hasForgotPassword,
});

export default connect(mapStateToProps, null)(withRouter(withAuthentication(Login)));



// WEBPACK FOOTER //
// ./src/components/Login/Login.js